// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3NwFh","head":"Table_head__3oJxs","col":"Table_col__1tpOz"};